import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toast } from './../UI/toast/Toast';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import withRedirect from '../../helpers/hoc/withRedirect';
import Label from 'reactstrap/es/Label';
import classNames from 'classnames';
import { useLocation } from 'react-router';
import { resetPasswordRequest } from '../../helpers/api/auth';

const PasswordResetForm = ({ setRedirect, setRedirectUrl, layout, hasLabel }) => {

  const search = useLocation().search;
  const authToken = new URLSearchParams(search).get('token');
  const email = new URLSearchParams(search).get('email');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      email,
      token: authToken,
      password,
      confirmPassword
    }

    try {
      await resetPasswordRequest(body);
      Toast.fire({
        type: 'success',
        title: `Logueate con tu nueva clave`,
      });
      setRedirect(true);
    } catch (error) {
      Toast.fire({
        type: 'error',
        title: `Ha ocurrido un error, espere un momento.`,
      });
    }
  }

  useEffect(() => {
    setRedirectUrl(`/authentication/login`);
  }, [setRedirectUrl, layout]);

  useEffect(() => {
    if (password === '' || confirmPassword === '') return setIsDisabled(true);

    setIsDisabled(password !== confirmPassword);
  }, [password, confirmPassword]);


  if (!authToken || !email) {
    setRedirect(true);
  }

  return  <>
            <Form className={classNames('mt-3', { 'text-left': hasLabel })} onSubmit={handleSubmit}>
              <FormGroup>
                {hasLabel && <Label>Nueva contraseña</Label>}
                <Input
                  placeholder={!hasLabel ? 'Nueva contraseña' : ''}
                  value={password}
                  onChange={({ target }) => setPassword(target.value)}
                  type="password"
                />
              </FormGroup>
              <FormGroup>
                {hasLabel && <Label>Confirmar contraseña</Label>}
                <Input
                  placeholder={!hasLabel ? 'Confirmar contraseña' : ''}
                  value={confirmPassword}
                  onChange={({ target }) => setConfirmPassword(target.value)}
                  type="password"
                />
              </FormGroup>
              <Button color="primary" block className="mt-3" disabled={isDisabled}>
                Establecer nueva contraseña
              </Button>
            </Form>
          </>
}

PasswordResetForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  setRedirectUrl: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

PasswordResetForm.defaultProps = { layout: 'basic', hasLabel: false };

export default withRedirect(PasswordResetForm);
